import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

export const NOTIFICATIONS_DISPLAY_INFO = 'notifications/displayInfo';
export const NOTIFICATIONS_DISPLAY_ERROR = 'notifications/displayError';

export interface NotificationState {
  snackbarText: string;
  messageColor: string;
  showMessage: boolean;
  isError: boolean;
}

export const state: NotificationState = {
  snackbarText: '',
  messageColor: 'white',
  showMessage: false,
  isError: false,
};

export const getters: GetterTree<NotificationState, any> = {
  notificationState: () => state,
};

export const mutations: MutationTree<NotificationState> = {
  setInfo(_, value) {
    state.isError = false;
    state.showMessage = true;
    state.snackbarText = value;
  },
  setError(_, value) {
    state.isError = true;
    state.showMessage = true;
    state.snackbarText = value;
  },
};

export const actions: ActionTree<NotificationState, any> = {
  displayInfo: ({ commit }, text: string) => {
    commit('setInfo', text);
  },
  displayError: ({ commit }, text: string) => {
    commit('setError', text);
  },
};

export const notifications: Module<NotificationState, any> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
